import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css, cx } from '@emotion/css'
import { formSectionTitleCss } from '../../legacy-design-system/text'
import { injector } from '../../ng-injector'
import { CodeSnippet } from '../../legacy-design-system/code-snippet'
import { CopyButton } from '../../design-system'

export interface AgentConfigProps {
  readonly fields: string[]
}

export class CustomMetadataAgentConfig extends React.Component<AgentConfigProps> {
  private agentInfoElement: any

  public render() {
    const { fields } = this.props

    const content =
      `application:\n  metadata: ` +
      fields.map((field) => `${field}="<value>"`).join(',')

    return !!fields && fields.length > 0 ? (
      <div>
        <div>
          <FormattedMessage id="title_customMetadata_agentConfig">
            {(text) => (
              <span
                className={cx(
                  formSectionTitleCss,
                  css`
                    margin-right: 10px;
                  `
                )}
              >
                {text}
              </span>
            )}
          </FormattedMessage>

          <FormattedMessage id="detail_customMetadata_agentConfigCopied">
            {(copiedMsg) => {
              return (
                <CopyButton
                  stringToCopy={
                    this.agentInfoElement && this.agentInfoElement.innerText
                  }
                  onClick={() => {
                    injector.invoke([
                      'ServiceUtils',
                      (ServiceUtils) =>
                        ServiceUtils.handleResolve('', {
                          log: ServiceUtils.LOGGER.SUCCESS
                        })({
                          data: {
                            success: true,
                            messages: [copiedMsg]
                          }
                        })
                    ])
                  }}
                />
              )
            }}
          </FormattedMessage>
        </div>

        <CodeSnippet>
          <span ref={(ref) => (this.agentInfoElement = ref)}>{content}</span>
        </CodeSnippet>
      </div>
    ) : (
      false
    )
  }
}
